import type { ChatMessage } from '../net/protocol';

const MAX_LINES = 200;

/** Appends a chat line. Text from the grid is untrusted: textContent only, never HTML. */
export function appendChat(log: HTMLOListElement, message: ChatMessage, isSelf: boolean): void {
  const li = document.createElement('li');
  li.className = isSelf ? 'self' : message.sourceType;

  if (message.sourceType !== 'system') {
    const from = document.createElement('span');
    from.className = 'from';
    from.textContent = `${message.fromName}: `;
    li.append(from);
  }
  li.append(document.createTextNode(message.text));

  const nearBottom = log.scrollHeight - log.scrollTop - log.clientHeight < 40;
  log.append(li);
  while (log.childElementCount > MAX_LINES) log.firstElementChild?.remove();
  if (nearBottom) log.scrollTop = log.scrollHeight;
}
